<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">黑名单列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">

                <a-button type="primary" @click="addblack">添加黑名单号码</a-button>

                <!-- <a-button type="primary" @click="openimport">导入数据</a-button> -->

                <a-button type="danger" @click="delusers" >删除数据</a-button>

            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    placeholder="关键字（手机号码）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                   
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  rowKey="id" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'cluedetail',query: {id:record.usxsid}}" >
                        {{ text }}
                    </router-link>

    
                    <!-- <span slot="action" slot-scope="text,record">
                        
                        <a href="javascript:;" @click="tokehu(record.usxsid,record.aid)" ><a-icon type="edit" /> 跟进</a>
                        <a href="javascript:;"  style="margin-left:5px" @click="todetail(record.usxsid,record.aid)"><a-icon type="copy"/> 详情</a>
                    </span> -->

                    <span slot="address" slot-scope="text,record">
                        {{record.province}}{{record.city}}{{record.area}}{{text}}
                    </span>

                    <span slot="sources" slot-scope="text">
                      <span>{{text}}</span>
                    </span>

                    <span slot="sex" slot-scope="text">
                      <span v-if="text==1">男</span>
                      <span v-if="text==2">女</span>
                    </span>
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 添加黑名单号码 -->
        <a-modal
        title="添加黑名单号码"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="khhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="添加号码">
                     <a-textarea v-model="telephone" placeholder="添加号码，多个号码请用英文','连接；例：13311111111,13388888888" :rows="8" />
                </a-form-item>

        
            </a-form>
        </a-modal>


<!-- 导入数据 -->
        <a-modal
            title="批量导入"
            :visible="importvisible"
            :confirm-loading="importconfirmLoading"
            @ok="importOk"
            @cancel="importhandleCancel"
            okText="确定"
            cancelText='取消'
            >
            <div class="import-form">

                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
                    <a-button v-if="buttonshow"> <a-icon type="folder-open" /> 上传文件 </a-button>
                </a-upload>
                <a v-if="buttonshow" :href="url" download="线索导入模板.xls">下载数据模板</a>
            </div>
        </a-modal>

    </div>
    
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import md5 from 'js-md5'
import { Modal } from 'ant-design-vue';
// import 'moment/locale/zh-cn';
 import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
 import VDistpicker from 'v-distpicker'
 Vue.component('v-distpicker',VDistpicker)
moment.locale('zh-cn');
import addresslist from '../../../static/address.json'
Vue.prototype.$moment = moment
import {formatDate} from '../../utils/formate.js'
const columns = [
    {title: 'ID',dataIndex: 'id',key: 'id',fixed: 'left',width:'130px'},
    {title: '黑名单号码',dataIndex: 'telephone',key: 'telephone'},
    {title: '添加时间',dataIndex:'addtime',key: 'addtime',scopedSlots: { customRender: 'date' }},
    // {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:160},
];

export default {
    filters: {
      //年-月-日
        formatDate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd')
        },
        topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        const adddata = [];
        return{
            locale,
            show:true,
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:{},
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

        
            // gjvisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            center:"center",

            usxsid:"",
            isvalid:0,


        

            selectedRowKeys: [],

            importvisible:false,
            importussid:"",
            importimtid:"",
            fileList:[],
            taglist:[],
            buttonshow:true,
            editvisible:false,

            disabled:true,
            telephone:"",
            importconfirmLoading:false,
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },

    mounted(){
       this.fetch()

        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
            })()
        };
    },
    methods:{
     
        // 删除
        delusers(){
            if(this.selectedRowKeys.length==0){
                this.$message.error("请选择数据");
            }{
                var id=this.selectedRowKeys.join(",")
                Modal.confirm({
                    title: '提示',
                    content: '您确定删除吗?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk:() => {
                        this.handok(id)
                    },
                    onCancel() {

                    },
                });
            }
           
        },
        handok(value){
            this.$axios.post('/api/telephoneblack/deltelephoneblack',{
                ids:value
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    // this.disabled=true
                    this.selectedRowKeys=[]
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        importhandleCancel(){
            this.importvisible=false
        },

         // 导入数据
        importhandleChange(value){
             console.log(value)
             this.importussid=value
         },
        taghandleChange(value){
            this.importimtid=value
         },
        openimport(){
            this.importvisible=true
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.buttonshow=true
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            this.buttonshow=false
            return false;
        },
        importOk(){
            this.importconfirmLoading=true
            var formData = new FormData();
            console.log(this.fileList[0])
            var file=this.fileList[0]
            console.log(file)
            formData.append('imgFile',file)
            formData.append('ussid',this.importussid)
            formData.append('imtid',this.importimtid)
            console.log(formData)
            this.$axios.post("/api/user/adduserxsimport",formData,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    'Content-Type':'multipart/form-data',
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.importconfirmLoading=false
                    this.importvisible=false
                    this.fetch()
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },


        // 多选框
        onSelectChange(selectedRows){
            // console.log(selectedRows)
            this.selectedRowKeys = selectedRows;

        },


        // 号码查询
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/telephoneblack/telephoneblacklist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },

        handleCancel(){
            this.editvisible=false
        },
           // 手动添加
        addblack(){
              this.editvisible=true
        },

        khhandleOk(){
            this.$axios.post('/api/telephoneblack/addtelephoneblack',{
                telephones:this.telephone,
                type:1
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.fetch()
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },


    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/blacklist.vue